import React from 'react';
import { Card, CardContent, Typography, Button, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const WordpressCard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card 
      sx={{ 
        maxWidth: 720,
        opacity: 0.6,
        filter: 'grayscale(0.3)',
        '&:hover': {
          opacity: 0.7,
        }
      }}
    >
      <CardContent>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ color: '#9ca3af' }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.469 6.825c.84 1.537 1.318 3.3 1.318 5.175 0 3.979-2.156 7.456-5.363 9.325l3.295-9.527c.59-1.964.44-4.077-1.19-5.807-.59-.59-1.22-.896-1.87-.896-.44 0-.873.12-1.25.37-.59.37-.896.9-.896 1.5 0 .44.12.87.37 1.25l-1.5 4.35-1.5-4.35c.25-.38.37-.81.37-1.25 0-.6-.31-1.13-.9-1.5-.38-.25-.81-.37-1.25-.37-.65 0-1.28.31-1.87.9-1.63 1.73-1.78 3.84-1.19 5.8l3.3 9.53C3.69 19.46 1.53 15.98 1.53 12c0-1.875.48-3.64 1.32-5.175C4.5 4.66 6.53 3.53 8.81 3.53c1.25 0 2.44.25 3.53.75C13.44 3.78 14.63 3.53 15.88 3.53c2.28 0 4.31 1.13 5.59 3.295zM12 21.75c-1.5 0-2.9-.44-4.1-1.19l4.1-11.9 4.1 11.9c-1.2.75-2.6 1.19-4.1 1.19z"/>
              </svg>
            </div>
            <div>
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.disabled' }}>
                {t('agents.wordpress.title')}
              </Typography>
              <Typography variant="body2" color="text.disabled">
                {t('agents.wordpress.comingSoon')}
              </Typography>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Chip 
              label={t('agents.wordpress.comingSoon')} 
              color="default" 
              size="small"
              sx={{ 
                backgroundColor: 'grey.300',
                color: 'grey.600'
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
          <Button 
            variant="contained" 
            disabled
            sx={{ 
              backgroundColor: 'grey.300',
              color: 'grey.500',
              '&:hover': {
                backgroundColor: 'grey.300',
              }
            }}
          >
            {t('agents.wordpress.connect')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default WordpressCard;
